import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { actions } from './sagaSlice';
import { Table, Container } from 'semantic-ui-react';
import Dimmer from '+/Dimmer';

const UnitList = props => {

    const {
        match, units, readAll, isFetching
    } = props;

    const { property_id } = match.params;

    useEffect(() => {
        readAll(property_id);
    }, [property_id, readAll]);


    if (isFetching) {
        return <Dimmer />;
    }

    return (
        <Container>

            <Table compact selectable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Unit #</Table.HeaderCell>
                        <Table.HeaderCell>Unit Type</Table.HeaderCell>
                        <Table.HeaderCell />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {
                        units
                        && units.map((unit, i) => (
                            <Table.Row key={i}>
                                <Table.Cell> {unit.name} </Table.Cell>
                                <Table.Cell> {unit.unit_type.name}</Table.Cell>
                                <Table.Cell collapsing>
                                    <Link to={`/properties/${property_id}/units/${unit.id}/orders`}>orders</Link>
                                </Table.Cell>

                            </Table.Row>
                        ))
                    }
                </Table.Body>

            </Table>
        </Container>
    );

};

const mapStateToProps = state => ({
    isFetching: state.units.isFetching,
    units: Object.values(state.units.data)
});

export default connect(mapStateToProps, actions)(UnitList);
